import Page, { PageContent } from "../models/page";
import React from 'react';
import styled from "styled-components";
import AddContentModal from "../views/add-content-modal";

const Wrapper = styled.div`
	padding: .5rem;
	border: 1px solid transparent;
	border-radius: 12px;
	cursor: pointer;
	color: #77992c;
	transition: .1s;
	font-weight: 500;
	font-size: 20px;
	line-height: 25px;
	&:hover {
		border-color: #EEEEEE;
	}
`;

const Heading = styled.input`
	appearance: none;
	border: none;
	font-weight: bold;
	font-size: 24px;
	&::placeholder {
		color: rgb(200,200,200);
	}
	&:focus {
		outline: none;
	}
`;

function SectionComponent(props: {
	content: PageContent,
	pageState: [Page, React.Dispatch<React.SetStateAction<Page>>],
	index: number
}) {
	const [content, setContent] = React.useState(props.content.value as PageContent[]);
	const [p, setPage] = props.pageState;

	const addContent = (c: PageContent) => {
		const page = {...p};
		const pageContent = [...page.content];
		const newContent = [...content, c];
		pageContent[props.index] = {type: "section", value: newContent};
		setPage(p => ({...p, content: pageContent}));
		setContent(newContent);
	};

	const [showAddContentModal, setShowAddContentModal] = React.useState(false);
	return <>
		<Wrapper>
			{content.length === 0 && <div style={{
				color: "#949494",
				fontWeight: "bold",
			}} onClick={() => setShowAddContentModal(true)}>
				Klicke, um Inhalt hinzuzufügen
			</div>}
			{content.map(c => <ContentToComponent content={c} pageState={props.pageState} index={props.index} />)}
		</Wrapper>
		{showAddContentModal &&
			<AddContentModal addContent={addContent} close={() => setShowAddContentModal(false)} nested />}
	</>
}

function HeadingComponent(props: {

}) {
	return <Heading placeholder="Überschrift" />
}

export default function ContentToComponent(props: {
	content: PageContent,
	index: number,
	pageState: [Page, React.Dispatch<React.SetStateAction<Page>>]
}) {
	if (props.content.type === "section") {
		return <SectionComponent pageState={props.pageState} content={props.content} index={props.index} />
	}
	if (props.content.type === "heading") {
		return <Wrapper>
			<HeadingComponent />
		</Wrapper>
	}
	return <div />
}